import React, { useEffect, useState } from 'react'
import { Button } from '@material-ui/core'
import { useDismissModal, useModal } from 'app/ducks/modal/hooks'
import useRequest from 'app/hooks/useRequest'
import HttpHandler from 'app/reusable/HttpHandler'
import { useToken } from 'app/ducks/auth/hooks'
import SurveyFillModal from './SurveyFillModal'

const minutesLabel = (minutes) => `${minutes} minuto${minutes === 1 ? '' : 's'}`

// The modal has no title/image, so SimpleModal's negative top margin (meant
// to pull those flush to the top) leaves the heading touching the dialog's
// top edge; `pt-6` restores the breathing room.
const SurveyPromptModalBody = ({ survey, onAccept, onDecline }) => (
  <div className="pt-6">
    <h3 className="text-center mb-4">Temos uma pesquisa rápida para você</h3>
    <p className="text-center">
      <b>{survey.name}</b>
    </p>
    <p className="text-center text-muted">
      Leva cerca de {minutesLabel(survey.estimated_minutes)} para responder.
    </p>
    <Button
      color="primary"
      variant="contained"
      size="large"
      className="w-full mt-4 mb-2"
      onClick={onAccept}
    >
      Responder agora
    </Button>
    <Button
      color="primary"
      variant="outlined"
      size="large"
      className="w-full"
      onClick={onDecline}
    >
      Agora não
    </Button>
  </div>
)

const SurveyPromptModal = () => {
  const pendingSurveysRequest = useRequest(
    HttpHandler.listPendingSurveys,
    'pendingSurveys',
    []
  )
  const showModal = useModal()
  const dismissModal = useDismissModal()
  const pendingSurveys = pendingSurveysRequest.response?.data?.data
  const [promptedSurveyId, setPromptedSurveyId] = useState(null)

  useEffect(() => {
    const survey = pendingSurveys?.[0]
    if (!survey || promptedSurveyId) return

    setPromptedSurveyId(survey.id)

    showModal({
      children: (
        <SurveyPromptModalBody
          survey={survey}
          onAccept={() => {
            dismissModal()
            showModal({
              children: <SurveyFillModal surveyId={survey.id} />,
              disableBackdropClick: true,
              persistent: true,
              id: `survey-fill-${survey.id}`,
            })
          }}
          onDecline={() => dismissModal()}
        />
      ),
      disableBackdropClick: true,
      persistent: true,
      id: `survey-prompt-${survey.id}`,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingSurveys, promptedSurveyId])

  return null
}

const LoginGuardedSurveyPromptModal = (props) => {
  const token = useToken()

  if (!token) return null
  return <SurveyPromptModal {...props} />
}

export default LoginGuardedSurveyPromptModal
